
import Vue from "vue";

import ProfileDropdown from "@/components/ProfileDropdown.vue";

export default Vue.extend({
	name: "AppHeader",
	components: {
		ProfileDropdown,
	},
	props: {
		authenticated: Boolean,
		user: Object,
		userManagerUrl: String,
		route: Object,
		theme: String,
		showUserTab: {
			type: Boolean,
			default: false,
		},
		showPartnerTab: {
			type: Boolean,
			default: false,
		},
		showStyleGuideTab: {
			type: Boolean,
			default: false,
		},
	},
});
